// src/utils/axiosSetup.js
import axios from "axios";
import { toast } from "react-toastify";

export const setupAxiosInterceptors = (logout) => {
  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      const errorMsg = err.response?.data?.error || "";
      if (err.response?.status === 401 || err.response?.status === 403) {
        logout(); // from AuthProvider
      }

      return Promise.reject(err);
    }
  );
};
